import { rgba } from 'polished';
import styled, { css } from 'styled-components';

export const Container = styled.label`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
`;

export const ToggleLabel = styled.label<{ $isSmall: boolean }>`
  display: inline-block;
  position: relative;
  width: ${({ $isSmall }) => ($isSmall ? '1.8rem' : '2.8rem')};
  height: ${({ $isSmall }) => ($isSmall ? '1rem' : '1.6rem')};

  border-radius: ${({ theme }) => theme.spacing(14)};
  background-color: ${({ theme }) => theme.palette.grey[400]};
  transition: background-color 200ms ease-in-out;
  pointer-events: none;

  &:after {
    content: '';
    position: absolute;
    left: ${({ theme, $isSmall }) => theme.spacing($isSmall ? 0.25 : 0.5)};
    top: 50%;

    width: ${({ $isSmall }) => ($isSmall ? '0.8rem' : '1.2rem')};
    height: ${({ $isSmall }) => ($isSmall ? '0.8rem' : '1.2rem')};

    transform: translateY(-50%);
    border-radius: 50%;
    background: ${({ theme }) => theme.palette.common.white};
    box-shadow: 0 0 1px 6px 0 ${({ theme }) => rgba(theme.palette.common.black, 0.19)}
    transition: left 200ms ease-in-out;
  }

  ${({ theme }) =>
    theme.isMobile &&
    css`
      width: 5.2rem;
      height: 3.2rem;

      &:after {
        width: 2.4rem;
        height: 2.4rem;
      }
    `};
`;

export const Input = styled.input<{ $isSmall: boolean }>`
  position: absolute;
  width: 0;
  height: 0;
  margin: 0;
  padding: 0;

  border: none;
  visibility: hidden;

  &:checked {
    + ${ToggleLabel} {
      background: ${({ theme }) => theme.palette.primary.main};

      &:after {
        left: ${({ theme, $isSmall }) =>
          `calc(100% - ${theme.isMobile ? '2.4rem' : $isSmall ? '0.6rem' : '1.2rem'} - ${theme.spacing($isSmall ? 0.75 : 0.5)})`};
      }
    }
  }
`;
